import { getCurrentIntl } from 'i18n/util/currentIntl'

export function getReferrerNameFromReferralCode({
  referralCode,
}: {
  referralCode?: string | null
}) {
  const intl = getCurrentIntl()
  const defaultName = intl.formatMessage({
    id: 'DeklHzfOK8nhcg_YSSHI',
    defaultMessage: 'your friend',
    description: 'Fallback referrer name shown when the referral code does not contain a name',
  })
  if (!referralCode) {
    return defaultName
  }
  const match = new RegExp('INVITE(.*)(.{6})$').exec(referralCode)
  if (match) {
    const name = match[1].toLowerCase()
    return name.charAt(0).toUpperCase() + name.slice(1)
  }
  return defaultName
}
